import { Auth } from "aws-amplify";
import config from "@/config/app";

function redirect(redirectPath, source) {
  if (redirectPath === false) {
    return
  }

  window.location.href =
    typeof redirectPath === "undefined" || redirectPath === true
      ? `/${source}`
      : `${config.vgw_platform.url}/${redirectPath}`;
}

export const logout = async function logout(redirectPath) {
  const queryParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(queryParams.entries());

  const resetUsername = params["rm-reset"] || params["source-email"];
  if (typeof resetUsername === "string") {
    window.localStorage.removeItem(`rm-${resetUsername}`);
    window.localStorage.removeItem(`rmt-${resetUsername}`);
  }

  const sourceParam = params["source"];
  let source = "";
  if (typeof sourceParam === "string" && sourceParam.length) {
    source = `?source=${sourceParam}`;
  }

  try {
    Auth.currentAuthenticatedUser().then(async (user) => {
      window.localStorage.removeItem(`sm-${user.username}`);
      await Auth.signOut();
    });
  } catch (e) {
    console.log(e);
  } finally {
    if (redirectPath) {
      redirect(redirectPath, source);
    }
  }
};
